(ns minorodata.connections.sources.facebook-adinsights
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]
            [mold-forms.core :as form-component]))



(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description (spec/nilable string?))


(spec/def ::bearer-token
  (spec/and (st/spec string? {:reason "Please provide a valid auth token"})
            (st/spec (complement c.string/blank?) {:reason "Auth token can't be empty"})))


(spec/def ::facebook-adinsights-form
  (spec/and
    (spec/keys :req-un [::name ::bearer-token]
               :opt-un [::description])))


(def source
  {:id           "facebook-adinsights"
   :enabled      false
   :name         "Facebook Adinsights (Legacy)"
   :description  "Efficiently reach all of the people who matter most"
   :image-source "facebook.png"
   :tags         ["marketing"]

   :preview-formatter
   (fn []
     (str "Authenticated by token"))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [bearer-token name description]} data]
        {:source-type "facebook-adinsights"
         :name        name
         :description description

         :source
         {:credentials {:bearer-token bearer-token}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge {:name        name
                :description description}
               (select-keys credentials [:bearer-token]))))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (partial form-component/validate-form ::facebook-adinsights-form)

    :id :facebook-adinsights-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :input
              :label      "Facebook Token"
              :name       :bearer-token
              :type       :password
              :required   true
              :value      ""}

             ;; {:block-type :oauth
             ;;  :label      "Facebook Login"
             ;;  :name       :bearer-token
             ;;  :required   true
             ;;
             ;;  :request-uri      "https://www.facebook.com/v7.0/dialog/oauth"
             ;;  :params-processor (fn [{:keys [client-id redirect-uri state scope response-type]}]
             ;;                      {:response_type response-type
             ;;                       :scope         scope
             ;;                       :client_id     client-id
             ;;                       :redirect_uri  redirect-uri
             ;;                       :state         state})
             ;;
             ;;  :response-processor (fn [response] (:code response))
             ;;
             ;;  :response-type "code"
             ;;  :client-id     "3418646844834967"
             ;;  :scope         "ads_management"}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status level destination-table attribution-windows]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:action              "append"
                    :level               level
                    :destination-table   destination-table
                    :attribution-windows attribution-windows}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:level :destination-table :attribution-windows])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :facebook-adinsight-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Level"
              :name       :level
              :options    [{:name "Campaign" :value "campaign"}
                           {:name "Adset"    :value "adset"}
                           {:name "Ad"       :value "ad"}]
              :required   true
              :value      "campaign"}

             {:block-type :select
              :label      "Attribution Windows"
              :name       :attribution-windows
              :options    [{:name "1d_view", :value "1d_view"}
                           {:name "7d_view", :value "7d_view"}
                           {:name "28d_view", :value "28d_view"}
                           {:name "1d_click", :value "1d_click"}
                           {:name "7d_click", :value "7d_click"}
                           {:name "28d_click", :value "28d_click"}]
              :required   true
              :multiple   true
              :native     false
              :value      []}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
